import text from '../languages/english/translate.json';

export function required(value) {
    if (value) {
        return "";
    }
    else {
        return text.validation.required;
    }
}
export function name(value) {
    let regEx = RegExp(/[a-z][A-Za-z ]{2,}/i);

    if (regEx.test(value)  && value.length < 191) {
        return "";
    }
    else {
        return text.validation.name;
    }
}
export function password(value) {
    const validPassword = RegExp(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/i);

    if (validPassword.test(value) && value.length > 3 && value.length < 20) {
        return "";
    }
    else {
        return text.validation.password;
    }
}
export function matchPassword(password , confirmPassword) {

    if (password === confirmPassword) {
        return "";
    }
    else {
        return text.validation.confirmPassword;
    }
}
export function email(value) {
    const validEmailRegex = RegExp(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i);

    if (validEmailRegex.test(value) &&  value.length < 100) {
        return "";
    }
    else {
        return text.validation.email;
    }
}
export function phone(value) {
    const validPhoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im ;
    if (validPhoneRegex.test(value) &&  value.length < 17) {
        return "";
    }
    else {
        return text.validation.phone;
    }
}
export function description(value) {
    if (value.length > 0 && value.length < 5000) {
        return "";
    }
    else {
        return text.validation.description;
    }
}
export function image(value) {

    if(value.type === 'image/jpeg' || value.type === 'image/jpg'  ||
        value.type === 'image/png' || 
        value.type === 'image/bmp' ){
         return "";
    }
    else{
         return text.validation.image;
    }
}
export function cv(value) {
    if(value.type === 'application/doc' || value.type === 'application/docx'  ||
        value.type === 'application/pdf' || value.type === 'application/txt' ||
        value.type === 'application/rtf' || value.type === 'application/xls' ||
        value.type === 'application/xlsx' || value.type === 'application/ppt' ||
        value.type === 'application/pptx' ||value.type === 'image/jpeg' || 
        value.type === 'image/jpg'  ||value.type === 'image/png' ||  value.type === 'image/bmp' ){
         return "";
    }
    else{
         return text.validation.cv;
    }
}
export function url(value){
    var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    console.log(text.validation)
    if (!value) {
        return "";
    } 
    else if (!regex.test(value)) {
        return text.validation.url;
    }
    else {
        return "";
    }
}
export function yearsOfEx(value){
    if(parseInt(value) > 0 && parseInt(value) < 31){
        return "";
    }
    else{
        return text.validation.yearsOfEx;
    }
}
export function salary(salaryfrom, salaryTo) {
    console.log(salaryfrom ,  salaryTo)
    let salary_from = parseInt(salaryfrom);
    let salary_to = parseInt(salaryTo);

    if ( salary_from < 0 || salary_to < 0) {
        return "Salary range should be a positive value.";
    }
    else if ( salary_from > 100000 || salary_to > 100000) {
        return "Please enter a valid input.";
    }
    else if ( salary_from > salary_to) {
        return "Salary from field should be less than salary to field.";
    }
    else if ( salary_from > 0 &&  salary_from < 100000 && salary_to > 0 && salary_to <100000 ){
        return "";
    }
    else {
        return "Salary range is required and must be a number.";
    }
}
export function validateForm(errors){
    let valid = true;
    Object.values(errors).forEach(
        // if we have an error string set valid to false
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}


